export class LaboratoryResultTypeModel {
    public laboratoryResultTypeId: number;
    public laboratoryResultTypeValue: number;
    public laboratoryResultTypeUnit?: string;
    public personalLaboratoryResult?: string;
    public isSystemType: boolean;
    public label?: string;
    public minValue: number;
    public maxValue: number;
}